import { connect } from "react-redux";
// Constants
import { sections } from "src/constants";

// UI Processors
import { createSectionSelectors } from "src/ui_processors";

// Components
import { SideBarHeaderComponent } from "src/components/side_bar_header_component";

function mapStateToProps(state) {
  return {
    saveFilterButtonEnabled: createSectionSelectors(
      sections.alerts
    ).saveFilterButtonEnabledSelector(state)
  };
}

export const SideBarAlertsHeaderContainer = connect(mapStateToProps)(
  SideBarHeaderComponent
);
